<template>
  <main class="main maintenance" role="main">
    <div class="main_con">
      <h1 class="ttl">서버 점검 안내</h1>
      <div class="con">
        <div class="txt">
          안정적인 서비스를 제공하기 위하여 <br />서버 점검 작업이 진행될
          예정입니다. <br /><br />
          작업시간 동안 모든 서비스가 일시적으로<br />
          중단되오니 양해 부탁 드립니다.
        </div>
        <div class="date_box">
          <hr />
          <span class="line">작업일시</span>
          <span class="txt">2025년 03월 17일 22:00 ~ 03월 18일 01:00</span>
          <hr />
        </div>
        <div class="txt">
          이용에 불편을 드려 죄송하며, <br />보다 개선된 서비스를 위해
          <br />최선을 다하겠습니다. 감사합니다.
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style></style>
